export const scrollTo = (element, topOrBottom = "top") => {
  if (!element) return;
  const rect = element.getBoundingClientRect();
  const doc = window.document;
  const roots = [doc.documentElement, doc.body];
  roots.forEach(root => {
    const target = rect[topOrBottom] + root.scrollTop;
    root.scrollTop = target;
  });
};

export const debounce = (func, wait, immediate) => {
  let timeout = null;
  return function() {
    const context = this;
    const args = arguments;
    const later = () => {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
};

const pad = x => (x.toString().length === 2 ? x : `0${x}`);

export const formatDate = date => {
  const y = date.getFullYear();
  const m = date.getMonth() + 1;
  const d = date.getDate();
  return `${y}-${pad(m)}-${pad(d)}`;
};

export const filterProducts = (choices, minDuration, maxDuration) =>
  choices.reduce((acc, c) => {
    const products = c.products.reduce((accP, p) => {
      if (p.structure !== undefined) {
        const found = p.structure.find(item => item.schedule !== undefined);
        return found !== undefined &&
          found.schedule.days >= minDuration &&
          found.schedule.days <= maxDuration
          ? [...accP, p]
          : accP;
      }
      return p.schedule.days < minDuration || p.schedule.days > maxDuration
        ? accP
        : [...accP, p];
    }, []);

    return products.length > 0 ? [...acc, { ...c, products }] : acc;
  }, []);

export const diffDates = (date1, date2) => {
  const dt1 = new Date(date1);
  const dt2 = new Date(date2);
  return Math.floor(
    (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
      Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
      (1000 * 60 * 60 * 24)
  );
};



// WEBPACK FOOTER //
// ./src/services/utils.js